import MenuType from '@/const/MenuType';
import ToastType from '@/const/ToastType';
import CookieKeys from '../../const/CookieKeys';
import Cookies from 'js-cookie';

/**
 * システムの状態
 */
const state = {

  // エラーページ
  fatalError: {
    code: 0,
    message: '',
    visible: false,
  },

  // toast typeにはerrorかinfoを指定することで背景色を変える
  toast: {
    type: ToastType.INFORMATION,
    message: '',
    visible: false,
    link: null
  },

  // sp用の下から出てくるmenu
  bottomMenu: {
    visible: false,
    title: '',
    items: [
      {
        text: '',
        icon: '',
        function: function () {},
        arg: null,  // functionに渡す引数。複数ある場合はargオブジェクトにまとめる
        disabled: false, // 項目を非活性にしたい時はtrueにする
        type: MenuType.NORMAL,
      },
    ]
  },

  // confirmダイアログ用
  confirmDialog: {
    visible: false,
    mainMessage: '',
    subMessage: '',
    executeButton: {
      text: '',
      function: function () {},
      arg: null,  // functionに渡す引数。複数ある場合はargオブジェクトにまとめる
    },
    returnButton: {
      text: '',
      function: function () {},
      arg: null,  // functionに渡す引数。複数ある場合はargオブジェクトにまとめる
    },
  },
  // スマートフォンのレイアウト表示用flagを指定する
  isMobile: false,
  // サイトID
  siteId: '',
  // カスタマイズデータを保持する
  customize: {
    langList: [],
    providesForNtj: false,
    allowedFeatures: {},
    poiCategories: '',
    primaryColor: '',
    secondaryColor: '',
    routeColor: '',
    accentColor: '',
    logo: {},
    officialSite: '',
    siteTopURL: {},
    overseasSite: {},
    favicon: '',
    title: '',
    pagesTitle: [],
    description: '',
    initialNotice: '',
    transportList: [],
    transportSectionList: [],
    poiDataSet: '',
    categories: [],
    recommendSpotsParams: {},
    planningSupport: {},
    linkWithRoute: {},
    linkWithRouteSections: {},
    article: false,
    shioriBanner: false,
    targetArea: '',
    poiSearchAreas: [],
    userType: '',
    cognito: {},
    externalLinks: {},
    recommendedPlans: {},
    recommendedPlanConditions: {},
    recommendedUsers: {},
    planTopCondition: '',
    loginRequired: {},
    useTripNote: false,
    sns: {},
    affiliate: {},
    informationUrl: '',
    informationHtml: [],
    accessiblePages: [],
    indexPages: [],
    gdpr: {},
    guideMapParam: {}
  },
  // エラーダイアログ（強制サイトTOP遷移）表示フラグ
  showPageAccessErrorDialog: false,
  // エラーダイアログ文言
  pageAccessErrorDialog: {
    title: '',
    text: '',
  },
  // ユーザーID（Cognito）
  userId: Cookies.get(CookieKeys.USER_ID_COOKIE_KEY),
};

export { state as default };
